<template>
  <v-card id="create">
    <v-speed-dial v-model="fab" :top="top" :direction="direction" :open-on-hover="hover" :transition="transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="pink darken-2" dark fab small>
          <v-icon>share</v-icon>
        </v-btn>
      </template>
      <div style="overflow-y: scroll;max-height: 200px">
        <v-btn @click="goToUrl(item.url, item.pattern)" color="pink" fab small v-for="item in computeFields">
          <img :src="item.img" alt="" class="img-fluid"    
        :height="item.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item.svg) ? '27px' : '30px'"
        :width="item.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item.svg) ? '27px' : '30px'"
>
        </v-btn>
      </div>
    </v-speed-dial>
  </v-card>
</template>

<script>
export default {
  name: 'floatingBtn',

  props: {
    value: {}
  },

  data: () => ({
    direction: 'top',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: false,
    left: false,
    transition: 'slide-y-reverse-transition'
  }),

  computed: {
    activeFab() {
      switch (this.tabs) {
        case 'one':
          return {'class': 'purple', icon: 'account_circle'}
        case 'two':
          return {'class': 'red', icon: 'edit'}
        case 'three':
          return {'class': 'green', icon: 'keyboard_arrow_up'}
        default:
          return {}
      }
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value).forEach(([x, y]) => {
        extra.push(...y)
      });

      return extra
    },
  },

  watch: {
    top(val) {
      this.bottom = !val
    },
    right(val) {
      this.left = !val
    },
    bottom(val) {
      this.top = !val
    },
    left(val) {
      this.right = !val
    }
  },

  methods: {
     isBigSvg(svg) {
    const list = [
      'svgdigikala',
      'svgbasalam',
      'svgsnappshop',
      'svgtechnolife',
      'svgtorob',
      'svgemalls',
      'svgrubika',
      'svgwhatsapp',
      'svgbale',
      'svgeitaa',
      'svgsoroush',
      'svgtelegram',
      'svgviber',
      'svgwechat',
      'svgsheypour',
      'svgdivar',
      'svgaparat',
      'svggap'
    ];
    return list.includes((svg || '').toLowerCase());
  },

    goToUrl(url, pattern = null) {
      let setUrl = ''
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith('http')) {
        if (emailRegex.test(url)) setUrl = 'mailto:'
        else if (pattern) setUrl = pattern.startsWith('http') ? pattern : 'https://' + pattern
        else setUrl = 'https://'
      }

      let a = document.createElement('a')
      a.setAttribute('href', setUrl + url)
      a.setAttribute('target', '_blank')
      a.click()
    },
  }
}
</script>

<style scoped>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>